import { EnumWorkspace, toWorkspace } from '@/contracts/system-modules/auth/enum/EnumWorkspace'

// Рабочее место прошлой сессии этого браузера: с ним устройство входит по сид-фразе.
// Хранилище может быть недоступно (приватный режим, запрет сайта) — тогда «Дом».
const WORKSPACE_KEY = 'extasy.workspace'

export function readWorkspace(): EnumWorkspace {
  try {
    return toWorkspace(localStorage.getItem(WORKSPACE_KEY))
  } catch {
    return EnumWorkspace.HOME
  }
}

export function writeWorkspace(workspace: EnumWorkspace): void {
  try {
    localStorage.setItem(WORKSPACE_KEY, workspace)
  } catch {
    // память браузера недоступна: вход по фразе возьмёт «Дом»
  }
}
